/**
 * @generated SignedSource<<8282a3ea3adf36bf0f3aba6c99524c4b>>
 * @relayHash 8ff8bb7722274dd0f92763bd4cc818ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dff4ed0df05c628ba404a0173e495e6fc4bb55e13c4923d1102315d1ba05fb9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiDeploymentsEmptyStateExperienceQuery$variables = {
  cloudId: string;
  projectAri: string;
};
export type uiDeploymentsEmptyStateExperienceQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareEmptyStateExperienceDeployments_EmptyStateTutorial">;
};
export type uiDeploymentsEmptyStateExperienceQuery = {
  response: uiDeploymentsEmptyStateExperienceQuery$data;
  variables: uiDeploymentsEmptyStateExperienceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v3 = {
  "kind": "Variable",
  "name": "from",
  "variableName": "projectAri"
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v5 = [
  {
    "concreteType": "AriGraphRelationship",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v1/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiDeploymentsEmptyStateExperienceQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_softwareEmptyStateExperienceDeployments_EmptyStateTutorial"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiDeploymentsEmptyStateExperienceQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "filter",
                "value": [
                  "DEPLOYMENT"
                ]
              }
            ],
            "kind": "LinkedField",
            "name": "devOpsProviders",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraDevOpsProvider"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "connectAppId"
                  }
                ],
                "type": "JiraClassicConnectDevOpsProvider"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "oauthAppId"
                  }
                ],
                "type": "JiraOAuthDevOpsProvider"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraDeploymentApp",
                "kind": "LinkedField",
                "name": "selectedDeploymentAppsProperty",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appKey"
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "alias": "deploymentRelationships",
                "args": [
                  {
                    "fields": [
                      (v3/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-deployment"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": (v5/*: any*/)
              },
              {
                "alias": "repoRelationships",
                "args": [
                  {
                    "fields": [
                      (v3/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-repo"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": (v5/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7dff4ed0df05c628ba404a0173e495e6fc4bb55e13c4923d1102315d1ba05fb9",
    "metadata": {},
    "name": "uiDeploymentsEmptyStateExperienceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "72c2bd6fec55bbd5bd454b21e837eed0";

export default node;
